export default "/images/logo-light.png?7c5f5b2c4a725fe5a4e321e207b4e50e";